import { useEffect } from 'react'
import PersonIcon from '../icons/person_outline_icon'
import CalendarIcon from '../icons/update_icon copy'
import SimpleLoader from '../Loader/SimpleLoader'
import useModalRedrive from '../../hooks/useModalRedrive'
import getRedriveTargetStep from '../../utils/getRedriveTargetStep'
import getDateFormat from '../../utils/getDateFormat'

export default function ModalRedriveExecution(){

    const {dataRedrive, cancelMd, confirmMd, loading, error } = useModalRedrive()
    const targetStep = getRedriveTargetStep(dataRedrive?.machine_input)

    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => { if(e.key === 'Escape' && !loading) cancelMd() }
        document.addEventListener('keydown', onKeyDown)
        return () => document.removeEventListener('keydown', onKeyDown)
    })

    return(
        <div className='modal-delete-container'>
            <div className='modal-dialog-confirm' role='dialog' aria-modal='true' aria-labelledby='redrive-md-title'>
                <p className='title-md' id='redrive-md-title'>Confirm redrive of failed task</p>
                <div className='md-item'>
                    <span>
                        <PersonIcon width='1rem' height='1rem' />
                    </span>
                    <p>Task: {dataRedrive.machine_name}</p>
                </div>
                <div className='md-item'>
                    <span>
                        <CalendarIcon width='1rem' height='1rem' />
                    </span>
                    <p>Start Date: {getDateFormat(dataRedrive.start_date)}</p>
                </div>
                <p className='md-redrive-detail'>
                    Clears {targetStep ? <strong>{targetStep}</strong> : 'this step'} and every step
                    after it on the parent run, then reconnects to the run already in flight — no new run is started.
                </p>
                { error && <p className='md-error' role='alert'>{error}</p> }
                <div className='container-buttons-md'>
                    <button onClick={() => cancelMd()} disabled={Boolean(loading)}>Cancel</button>
                    <button className='confirm-btn-md confirm-md-enabled'
                            onClick={() => confirmMd()}
                            disabled={Boolean(loading)}>
                                {
                                    loading?
                                    <SimpleLoader /> :
                                    <span>{ error ? 'Retry redrive' : 'Yes, redrive' }</span>
                                }
                    </button>
                </div>
            </div>
        </div>
    )
}
